export class UserSetup{
    weekplanningDefaultDateRange: number;
}